// extracted by mini-css-extract-plugin
module.exports = {"SectionTitle":"PieChartSection_SectionTitle__ZpLPd"};